module.exports = __webpack_public_path__ + "static/media/6_3.705674bc.jpg";